import { gql } from '@apollo/client';

export const GET_INVOICE_AGING_PLACEMENTS = gql`
  query InvoiceAgingPlacements($filters: InvoiceAgingFilter) {
    invoiceAgingPlacements(filters: $filters) {
      rows {
        id
        placementId
        candidateId
        candidateName
        jobOrderId
        jobTitle
        jobCity
        jobStateCode
        salaryAmount
        netCommission
        placedDate
        startDate
        invoiceNumber
        fallbackInvoiceNumber
        invoiceReceivedDate
        payableTerm
        replacementTerm
        placementStatus
        companyId
        companyName
        accountManagerName
        recruiterName
      }
      count
      capped
      cap
    }
  }
`;

export type PlacementStatus =
  | 'ACCOUNTING_APPROVED'
  | 'ACCOUNTING_INVOICED'
  | 'PAID';

export interface InvoiceAgingPlacementRow {
  id: string;
  placementId: number;
  candidateId: string | null;
  candidateName: string | null;
  jobOrderId: string | null;
  jobTitle: string | null;
  jobCity: string | null;
  jobStateCode: string | null;
  salaryAmount: number | null;
  netCommission: number | null;
  placedDate: string | null;
  startDate: string | null;
  invoiceNumber: string | null;
  fallbackInvoiceNumber: string | null;
  invoiceReceivedDate: string | null;
  payableTerm: string | null;
  replacementTerm: string | null;
  placementStatus: PlacementStatus;
  companyId: string | null;
  companyName: string | null;
  accountManagerName: string | null;
  recruiterName: string | null;
}

export interface InvoiceAgingResult {
  rows: InvoiceAgingPlacementRow[];
  count: number;
  capped: boolean;
  cap: number;
}

export interface InvoiceAgingQueryData {
  invoiceAgingPlacements: InvoiceAgingResult;
}

export interface InvoiceAgingFilter {
  companySearch?: string;
  jobTitleSearch?: string;
  candidateSearch?: string;
  statuses?: string[];
}
